module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71999/img/blog-post-zero.png"